import { FC } from 'react';

import { FileBrowserStorageObjectFragment } from '../../graphql/generated';
import { isFile } from '../../graphql/utils/utils';
import { formatTimestamp } from '../../utils/date/date';
import { Placeholder } from './search-results-list';

type Props = {
  object: FileBrowserStorageObjectFragment;
};

export const UpdatedAt: FC<Props> = ({ object }) => {
  if (isFile(object) && object.updatedAt) {
    return <>{formatTimestamp(object.updatedAt)}</>;
  }
  return <Placeholder />;
};
